import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

import {   ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  props: {
    params: null
  },
  setup(__props: any) {

const props = __props as {
  params?: any
}

let { 
  // 获取订单
  'POST/order/receivable/flows': fetchList,
} = Api


const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

fetchData(props.params)



return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "max-height": "660px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "账户ID",
          prop: "accountNumber",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "currency"
        }),
        _createVNode(_component_el_table_column, {
          label: "收款金额",
          prop: "receiptAmount",
          width: "100",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "本位币",
          prop: "standardMoney",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "日期",
          prop: "collectionAt",
          width: "115"
        }),
        _createVNode(_component_el_table_column, {
          label: "公司名称",
          prop: "costFrom",
          width: "230",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "账户简称",
          prop: "accountName",
          width: "135",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "借方",
          prop: "costOut",
          align: "right",
          width: "100",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "贷方",
          prop: "costIn",
          width: "100",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "收款币别",
          prop: "receiptCurrency",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "手续费",
          prop: "handlingFee",
          align: "right",
          width: "100",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "收付方名称",
          prop: "costTo",
          width: "200",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "银行摘要",
          prop: "summary",
          width: "200",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "款项类型",
          prop: "paymentType",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "remarks",
          width: "130",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "团队",
          prop: "team"
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          prop: "status"
        }),
        _createVNode(_component_el_table_column, {
          label: "导入批次",
          prop: "fileId",
          width: "150"
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      "page-sizes": [10, 30, 50, 100],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
  ]))
}
}

})